import * as React from 'react';

interface IProps {
	className?: string;
}

export const XIcon: React.FC<IProps> = ({ className }) => {
	return (
		<svg
			className={className}
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		>
			<circle cx='12' cy='12' r='11' />
			<path d='m15 9-6 6' />
			<path d='m9 9 6 6' />
		</svg>
	);
};
